import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { putMBMCampaign, deleteMBMCampaign, postCampaignCopy } from "services/ConfigServices";
import useCampaignsTable from "./useCampaignsTable.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { campaigntext } from "variables/MBM/campaign";
import { definitionData, eosprotocoleData } from "variables/MBM/lists/iotdevices";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import { statusData } from "variables/MBM/lists/campaign"
import CampaignEditionDialog from "./CampaignEditionDialog.js";
import CampaignManagementDialog from "./CampaignManagementDialog";
import CampaignDuplicateDialog from "./CampaignDuplicateDialog";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import FileCopyIcon from '@mui/icons-material/FileCopy';

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTCampaigns = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_campaigns_admin = permis.includes("mbm_campaigns_admin");
  const mbm_campaigns_manage = permis.includes("mbm_campaigns_manage");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [open, setOpen] = useState(false);
  const [openManagement, setOpenManagement] = useState(false);
  const [openDuplicate, setOpenDuplicate] = useState(false);
  const [currentCampaign, setCurrentCampaign] = useState(null);
  const { gridState, refetch, setCampaigns } = useCampaignsTable();

  let dataCampaigns = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: campaigntext.name,
      selector: (row) => row.parameters.general.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters.general.name,
    },
    {
      name: campaigntext.status,
      selector: (row) => row.parameters.general.status,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => statusData.find((x) => x.id == row.parameters.general.status)?.name || ""
    },
    {
      name: campaigntext.datebegin,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.parameters.general.datebegin && moment(row.parameters.general.datebegin).isValid()
          ? moment(row.parameters.general.datebegin).format("DD/MM/YYYY")
          : "",
    },
    {
      name: campaigntext.dateend,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        row.parameters.general.dateend && moment(row.parameters.general.dateend).isValid()
          ? moment(row.parameters.general.dateend).format("DD/MM/YYYY")
          : "",
    },
    {
      name: campaigntext.incharge,
      selector: (row) => row.parameters.general.incharge,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters.general.incharge,
    },
    {
      name: campaigntext.group,
      selector: (row) => row.parameters.general.groupid,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.parameters.general.groups] || ""
    },
    {
      name: campaigntext.description,
      selector: (row) => row.parameters.general.description,
      sortable: true,
      cell: (row) => row.parameters.general.description,
    },
    {
      name: "",
      sortable: false,
      width: "15rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {mbm_campaigns_manage &&
              <>
                {

                  (row.parameters.general.status === 'pending' || row.parameters.general.status === 'finished') ?
                    <Tooltip title="Lancer la campagne">
                      <Button
                        onClick={updateCampaign(row, 'start')}
                        color={"success"}
                        className={classes.actionButton}
                      >
                        <PlayArrowIcon fontSize="large" />
                      </Button>
                    </Tooltip>
                    :
                    <Tooltip title="Arrêter la campagne">
                      <Button
                        onClick={updateCampaign(row, 'stop')}
                        color={"warning"}
                        className={classes.actionButton}
                      >
                        <StopIcon fontSize="large" />
                      </Button>
                    </Tooltip>
                }
              </>
            }
            {mbm_campaigns_manage && (
              <Tooltip title="Gérer la campagne">
                <Button
                  onClick={manageCampaign(row)}
                  color={"info"}
                  className={classes.actionButton}
                >
                  <VisibilityIcon fontSize="large" />
                </Button>
              </Tooltip>
            )}
            {mbm_campaigns_admin && (
              <>
                <Tooltip title="Editer la campagne">
                  <Button
                    onClick={editCampaign(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Dupliquer la campagne">
                  <Button
                    onClick={duplicateCampaign(row)}
                    color={"info"}
                    className={classes.actionButton}
                  >
                    <FileCopyIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Supprimer la campagne">
                  <CustomDeleteButton
                    deleteTitle={"Suppression de la campagne"}
                    deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la campagne ${row.parameters.general.name}?`}
                    handleSupprimer={deleteCampaignFunction(row)}
                  />
                </Tooltip>
              </>
            )}
          </div>
        </>
      ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const handleClickManagementOpen = () => {
    setOpenManagement(true);
  };
  const handleEditManagementClose = () => {
    setOpenManagement(false);
  };

  const handleClickDuplicateOpen = () => {
    setOpenDuplicate(true);
  };
  const handleDuplicateClose = () => {
    setOpenDuplicate(false);
  };

  const editCampaign = (row) => async () => {
    let obj = dataCampaigns.find((o) => o.id === row.id);
    if (obj) {
      setCurrentCampaign(obj);
      handleClickOpen();
    }
  }

  const duplicateCampaign = (row) => async () => {
    let obj = dataCampaigns.find((o) => o.id === row.id);
    if (obj) {
      setCurrentCampaign(obj);
      handleClickDuplicateOpen();
    }
  }

  const manageCampaign = (row) => async () => {
    let obj = dataCampaigns.find((o) => o.id === row.id);
    if (obj) {
      setCurrentCampaign(obj);
      handleClickManagementOpen();
    }
  }

  const deleteCampaignFunction = (row) => async () => {
    let obj = dataCampaigns.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let selected = [];
    selected.push(idSelected);
    let url = deleteMBMCampaign(idSelected);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `La campagne a été supprimée`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const updateCampaign = (row, action) => async () => {
    let obj = dataCampaigns.find((o) => o.id === row.id);
    if (obj) {
      const general = {
        ...obj.parameters.general,
      }
      if (action === 'start') {
        general.status = 'started';
        general.datebegin = moment().format("YYYY-MM-DD");
      }
      else if (action === 'stop') {
        general.status = 'finished';
        general.dateend = moment().format("YYYY-MM-DD");
      }
      const parameters = {
        ...obj.parameters,
        general,
      }
      axios
        .put(
          putMBMCampaign(obj.id),
          {
            parameters,

          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              "Content-Type": "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            setNotification("success", "Campagne modifiée");
            refetch();
          } else setNotification("error", "Une erreur est survenue");
        })
        .catch((error) => {
          setNotification("error", "Une erreur est survenue");
          // setLoading(false);
        });
    }
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setCampaigns(selection.selectedRows);
  };


  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucune campagne à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        highlightOnHover
        pointerOnHover
        onRowClicked={(row) => {
          let obj = dataCampaigns.find((o) => o.id === row.id);
          if (obj && mbm_campaigns_manage) {
            setCurrentCampaign(obj);
            handleClickManagementOpen();
          }
        }
        }
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        expandableRowDisabled={(row) => row.disabled}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="lg"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          {'Edition de la campagne ' + currentCampaign?.parameters?.general?.name}
        </CustomDialogTitle>
        <DialogContent dividers style={{ height: "90vh" }}>
          <CampaignEditionDialog
            currentCampaign={currentCampaign}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditManagementClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="lg"
        open={openManagement}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditManagementClose}>
          {'Gestion de la campagne ' + currentCampaign?.parameters?.general?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <CampaignManagementDialog
            currentCampaign={currentCampaign}
            closeModal={handleEditManagementClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleDuplicateClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openDuplicate}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleDuplicateClose}>
          {'Dupliquer la campagne ' + currentCampaign?.parameters?.general?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <CampaignDuplicateDialog
            currentCampaign={currentCampaign}
            closeModal={handleDuplicateClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTCampaigns;
